import { links } from "data";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";
import { AccordionLink } from "./accordion-link";

export const SERVICES_ACCORDION_KEY = "SERVICES_ACCORDION_KEY";

export const ServicesAccordion = () => {
  return (
    <AccordionContainer accordionKey={SERVICES_ACCORDION_KEY}>
      <div className="flex flex-column">
        <AccordionLink href={links.COURIER_SERVICES}>
          Courier services
        </AccordionLink>
        <AccordionLink href={links.SAME_DAY_DELIVERY}>
          Same day courier
        </AccordionLink>
        <AccordionLink href={links.NEXT_DAY_DELIVERY}>
          Next day delivery
        </AccordionLink>
        <AccordionLink href={links.INTERNATIONAL_DELIVERY}>
          International delivery
        </AccordionLink>
        <AccordionLink href={links.MULTI_DROP_COURIER}>
          Multi-drop courier
        </AccordionLink>
        <AccordionLink href={links.IT_RELOCATION}>IT relocation</AccordionLink>
        <AccordionLink href={links.CONTACT_RUNS}>Contract runs</AccordionLink>
        <AccordionLink href={links.LOGISTICS_SERVICES}>
          Logistics services
        </AccordionLink>
        <AccordionLink href={links.STORAGE_PICK_PACK}>
          Storage, pick & pack
        </AccordionLink>
        <AccordionLink href={links.FREIGHT_SERVICES}>
          Freight services
        </AccordionLink>
        <AccordionLink href={links.IN_NIGHT_DELIVERY}>
          In-night delivery
        </AccordionLink>
        <AccordionLink href={links.REFRIGERATED_VEHICLES}>
          Refrigerated vehicles
        </AccordionLink>
        <AccordionLink href={links.HEALTHCARE_SERVICES}>
          Healthcare services
        </AccordionLink>
        <AccordionLink href={links.HOSPITAL_LOGISTICS}>
          Hospital Logistics
        </AccordionLink>
        <AccordionLink href={links.BLOOD_AND_ORGAN}>
          Blood and organ transportation
        </AccordionLink>
        <AccordionLink href={links.CLINICAL_TRIAL}>
          Clinical trial logistics
        </AccordionLink>
        <AccordionLink href={links.PATHOLOGY_SOLUTIONS}>
          Pathology solutions
        </AccordionLink>
        <AccordionLink href={links.PHARMACY_TO_HOME}>
          Pharmacy to home
        </AccordionLink>
        <AccordionLink href={links.WHOLESALER_LOGISTICS}>
          Wholesaler logistics
        </AccordionLink>
        <span className={styles.subtitle}>by industry...</span>
        <AccordionLink href={links.HEALTHCARE}>Healthcare</AccordionLink>
        <AccordionLink href={links.RETAIL}>Retail</AccordionLink>
        <AccordionLink href={links.PUBLIC_SECTOR}>Public sector</AccordionLink>
        <AccordionLink href={links.FACILITIES_MANAGEMENT}>
          Facilities management
        </AccordionLink>
      </div>
    </AccordionContainer>
  );
};
